<template>
  <div class="result w-full bg-white">
    <div id="info-card" class="bg-white px-4 py-6 mb-2">
      <h1 class="font-semibold text-2xl mb-5">
        Aktivitas Kehidupan Sehari-hari (AKS)
      </h1>

      <!-- LIST AKS -->

      <p class="text-base">
        Mengendalikan rangsang Buang Air Besar (BAB)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tidak terkendali/tak teratur (perlu pencahar)</p>
          <Checked v-if="aksVal?.fesesControl === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Kadang-kadang tak terkendali (1x/minggu)</p>
          <Checked v-if="aksVal?.fesesControl === 'OCCASIONAL_CONTROL'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Terkendali teratur</p>
          <Checked v-if="aksVal?.fesesControl === 'REGULAR_CONTROL'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Mengendalikan rangsang Buang Air Kecil (BAK)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tak terkendali atau pakai kateter</p>
          <Checked v-if="aksVal?.urinatingControl === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Kadang-kadang tak terkendali (1x/24 jam)</p>
          <Checked v-if="aksVal?.urinatingControl === 'OCCASIONAL_CONTROL'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.urinatingControl === 'REGULAR_CONTROL'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Membersihkan diri (mencuci wajah, menyikat rambut, mencukur kumis, sikat gigi)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Butuh pertolongan orang lain</p>
          <Checked v-if="aksVal?.selfCare === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.selfCare === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Penggunaan WC (keluar masuk WC, melepas/memakai celana, cebok, menyiram)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tergantung pertolongan orang lain</p>
          <Checked v-if="aksVal?.wcUsage === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Perlu pertolongan pada beberapa kegiatan, tetapi dapat mengerjakan sendiri di beberapa kegiatan lain</p>
          <Checked v-if="aksVal?.wcUsage === 'PARTIAL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.wcUsage === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Makan dan minum (jika makan harus berupa potongan, dianggap dibantu)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tidak mampu</p>
          <Checked v-if="aksVal?.eatingAndDrinking === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Perlu ditolong memotong makanan</p>
          <Checked v-if="aksVal?.eatingAndDrinking === 'PARTIAL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.eatingAndDrinking === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Bergerak dari kursi roda ke tempat tidur dan sebaliknya (termasuk duduk di tempat tidur)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tidak mampu</p>
          <Checked v-if="aksVal?.movementToBed === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Perlu banyak bantuan untuk bisa duduk (2 orang)</p>
          <Checked v-if="aksVal?.movementToBed === 'FULL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Bantuan minimal 1 orang</p>
          <Checked v-if="aksVal?.movementToBed === 'PARTIAL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.movementToBed === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Berjalan di tempat rata (atau jika tidak bisa berjalan, menjalankan kursi roda)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tidak mampu</p>
          <Checked v-if="aksVal?.flatSurfaceWalking === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Bisa (pindah) dengan kursi roda</p>
          <Checked v-if="aksVal?.flatSurfaceWalking === 'FULL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Berjalan dengan bantuan 1 orang</p>
          <Checked v-if="aksVal?.flatSurfaceWalking === 'PARTIAL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.flatSurfaceWalking === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Berpakaian (termasuk memasang tali sepatu, mengencangkan sabuk)
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tergantung orang lain</p>
          <Checked v-if="aksVal?.dressing === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Sebagian dibantu (misal: mengancing baju)</p>
          <Checked v-if="aksVal?.dressing === 'PARTIAL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.dressing === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Naik turun tangga
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tidak mampu</p>
          <Checked v-if="aksVal?.stairsClimbing === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Butuh pertolongan</p>
          <Checked v-if="aksVal?.stairsClimbing === 'PARTIAL_ASSISTANCE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.stairsClimbing === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-base">
        Mandi
      </p>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tergantung orang lain</p>
          <Checked v-if="aksVal?.bathing === 'NOT_ABLE'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Mandiri</p>
          <Checked v-if="aksVal?.bathing === 'INDEPENDENT'" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

    </div>

    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  computed,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import Loading from '@/components/LoadingOverlay.vue';
import Checked from '@/components/icons/Checked.vue';
import Unchecked from '@/components/icons/Unchecked.vue';

// import sanitizeHtml from 'sanitize-html';
const store = useStore();
const route = useRoute();

// const sanitizeOptions = ref({
//   allowedTags: ['ol', 'li', 'br', 'p', 'b'],
// });

const screeningResult = computed(() => {
  let result = store.state.screening.screeningData[store.state.screening.screeningIndex];
  if (route?.query?.page) {
    result = store.state.screening.screeningData[route?.query?.page - 1];
    store.dispatch('screening/setScreeningIndex', route?.query?.page - 1);
  }
  return result;
});

const aksVal = computed(() => screeningResult.value?.aks || {});

</script>

<script>
export default {
  name: 'AksDetailView',
};
</script>

<style lang="scss" scoped>

</style>
